import { FC, HTMLProps } from 'react';

export const ArrowRightIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_169_2793)">
        <path
          d="M4.74778 0.232381C4.9483 0.0592041 5.17617 -0.0182695 5.43138 -4.00543e-05C5.68658 0.0181894 5.90078 0.127563 6.07395 0.328084L11.1872 6.38472C11.3422 6.5579 11.4197 6.76298 11.4197 6.99996C11.4197 7.23694 11.3422 7.44202 11.1872 7.61519L6.07395 13.6718C5.90078 13.8724 5.68658 13.9817 5.43138 14C5.17617 14.0182 4.9483 13.9407 4.74778 13.7675C4.54726 13.6035 4.43789 13.3893 4.41966 13.125C4.40143 12.8606 4.4789 12.6282 4.65208 12.4277L9.24583 6.99996L4.65208 1.57222C4.4789 1.3717 4.40143 1.13928 4.41966 0.874959C4.43789 0.610636 4.54726 0.396443 4.74778 0.232381Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_169_2793">
          <rect width="14" height="14" fill="white" transform="matrix(1 0 0 -1 0.919983 14)" />
        </clipPath>
      </defs>
    </svg>
  );
};
